import React, { useState } from "react";
import Index from "../Index";
import MenuItemList from "./MenuItemList";
import { NavLink } from "react-router-dom";

function SideBar({ addClass, closeSidebar }) {
  const location = Index.useLocation();

  const { type, permissions, priceType, companySetup } = Index.useSelector((state) => {
    return state.ERPAdminReducer;
  });


  const masterMaintenanceMenuList = [
    {
      name: "Master Maintenance",
      type: "company",
      icon: "mastermaintenance",
      permission: permissions?.includes("master_maintenance_view"),
      child: [
        {
          name: "Account Master",
          link: "",
          type: "company",
          icon: "accountmaster",
          permission: permissions?.includes("account_master_main_view"),
          child: [
            {
              name: "Account Group Master",
              link: "/dashboard/account-group-master",
              type: "company",
              icon: "accountgroupmaster",
              permission: permissions?.includes("account_group_master_view"),
            },
            {
              name: "Account Master",
              link: "/dashboard/account-master",
              type: "company",
              icon: "inneraccountmaster",
              permission: permissions?.includes("account_master_view"),
            },
            {
              name: "Opening Balance",
              link: "/dashboard/opening-balance",
              type: "company",
              icon: "openingbalance",
              permission: permissions?.includes("opening_balance_view"),
            },
          ],
        },
        {
          name: "Product Master",
          link: "",
          type: "company",
          icon: "productmaster",
          permission: permissions?.includes("product_master_main_view"),
          child: [
            {
              name: "Product Group Master",
              link: "/dashboard/prouduct-group-master",
              type: "company",
              icon: "productgroupmaster",
              permission: permissions?.includes("product_group_master_view"),
            },
            {
              name: "Product Master",
              link: "/dashboard/product-master",
              type: "company",
              icon: "innerproductmaster",
              permission: permissions?.includes("product_master_view"),
            },
            {
              name: "Product Category Master",
              link: "/dashboard/product-category-master",
              type: "company",
              icon: "productcategorymaster",
              permission: permissions?.includes("product_category_master_view"),
            },
            {
              name: "Barcode Master",
              link: "/dashboard/barcode-list",
              type: "company",
              icon: "barcodemaster",
              permission: permissions?.includes("barcode_master_view"),
              // permission: 1,
            },
            {
              name: "HSN Master",
              link: "/dashboard/HSN-master",
              type: "company",
              icon: "hsnmaster",
              permission: permissions?.includes("hsn_master_view"),
            },
            {
              name: "Opening Stock",
              type: "company",
              icon: "openingstock",
              permission: permissions?.includes("opening_stock_view"),
              child: [
                {
                  name: "Finish Stock",
                  link: "/dashboard/finish-stock",
                  type: "company",
                  icon: "finishstock",
                  permission: permissions?.includes("finish_stock_view"),
                },
                {
                  name: "Other Stock",
                  link: "/dashboard/opening-stock",
                  type: "company",
                  icon: "otherstock",
                  permission: permissions?.includes("other_stock_view"),
                },
              ],
            },
            {
              name: "Price List",
              type: "company",
              icon: "pricelist",
              permission: permissions?.includes("item_wise_size_wise_view"),
              child: [
                {
                  name: "Price List Mark Down",
                  link: "/dashboard/item-size-price-list-down",
                  type: "company",
                  icon: "pricedown",
                  permission:
                    permissions?.includes("item_size_price_down_view") &&
                    priceType == "down",
                },
                {
                  name: "Price List Mark Up",
                  link: "/dashboard/item-size-price-list-up",
                  type: "company",
                  icon: "priceup",
                  permission:
                    permissions?.includes("item_size_price_up_view") &&
                    priceType == "up",
                },
              ],
            },
          ],
        },
        {
          name: "Tax Master",
          link: "",
          type: "company",
          icon: "taxmaster",
          permission: permissions?.includes("tax_master_main_view"),
          child: [
            {
              name: "Tax Master",
              link: "/dashboard/tax-master",
              type: "company",
              icon: "innertaxmaster",
              permission: permissions?.includes(
                "sales_expenses_tax_master_view"
              ),
            },
            {
              name: "Tax Category Master",
              link: "/dashboard/tax-category-master",
              type: "company",
              icon: "taxcategorymaster",
              permission: permissions?.includes("tax_category_master_view"),
            },
          ],
        },
      ],
    },
    {
      name: "Other Master",
      type: "company",
      icon: "othermaster",
      permission: permissions?.includes("master_view"),
      child: [
        {
          name: "Godown Master",
          link: "/dashboard/godwon-master",
          type: "company",
          icon: "godownmaster",
          permission: permissions?.includes("godown_master_view"),
        },
        {
          name: "Area Master",
          link: "/dashboard/area-master",
          type: "company",
          icon: "areamaster",
          permission: permissions?.includes("area_master_view"),
        },
        {
          name: "Narration Master",
          link: "/dashboard/narration-master",
          type: "company",
          icon: "narrationmaster",
          permission: permissions?.includes("narration_master_view"),
        },
        {
          name: "Department Master",
          link: "/dashboard/department-master",
          type: "company",
          icon: "departmentmaster",
          permission: permissions?.includes("department_master_view"),
        },
        {
          name: "Size Master",
          link: "/dashboard/size-master",
          type: "company",
          icon: "sizemaster",
          permission: permissions?.includes("size_master_view"),
        },
        {
          name: "Colour Master",
          link: "/dashboard/colour-master",
          type: "company",
          icon: "colormaster",
          permission: permissions?.includes("colour_master_view"),
        },
        {
          name: "Set Master",
          link: "/dashboard/set-master",
          type: "company",
          icon: "setmaster",
          permission: permissions?.includes("set_master_view"),
        },
        {
          name: "Process Master",
          link: "/dashboard/process-master",
          type: "company",
          icon: "processmaster",
          permission: permissions?.includes("process_master_view"),
        },
        {
          name: "Cost Group Master",
          link: "/dashboard/cost-group-master",
          type: "company",
          icon: "costgroupmaster",
          permission: permissions?.includes("cost_group_master_view"),
        },
        {
          name: "Fixed Assets",
          link: "/dashboard/fixed-assets",
          type: "company",
          icon: "fixedasset",
          permission: permissions?.includes("fixed_assets_master_view"),
        },
        {
          name: "Currency Master",
          link: "/dashboard/currency-master",
          type: "company",
          icon: "openingbalance",
          permission: permissions?.includes("currency_master_view"),
        },
      ],
    },
    {
      name: "Daily Entry",
      type: "company",
      icon: "dailyentry",
      permission: permissions?.includes("daily_entry_view"),
      child: [
        {
          name: "Purchase",
          link: "",
          type: "company",
          icon: "purchaseions",
          permission: permissions?.includes("daily_entry_purchase_view"),
          child: [
            {
              name: "GRN Entry",
              link: "/dashboard/grn-list",
              type: "company",
              icon: "grnentry",
              permission: permissions?.includes("grn_entry_view"),
            },
            {
              name: "Purchase Entry",
              link: "/dashboard/purchase-entry-list",
              type: "company",
              icon: "purchaselist",
              permission: permissions?.includes("purchase_entry_view"),
            },
            {
              name: "Purchase Entry(Size Wise)",
              link: "/dashboard/purchase-entry-size-wise-list",
              type: "company",
              icon: "purchasentrysizewise",
              permission: permissions?.includes(
                "purchase_entry_size_wise_view"
              ),
            },
            {
              name: "Purchase Return",
              link: "/dashboard/purchase-return-list",
              type: "company",
              icon: "purchasereturn",
              permission: permissions?.includes("purchase_return_view"),
            },
          ],
        },
        {
          name: "Sales",
          link: "",
          type: "company",
          icon: "salesicons",
          permission: permissions?.includes("daily_entry_sales_view"),
          child: [
            {
              name: "Packing / Challan Entry",
              link: "/dashboard/packing-slip-list",
              type: "company",
              icon: "challanentry",
              permission: permissions?.includes("packing_challan_entry_view"),
            },
            {
              name: "Sales Entry",
              link: "/dashboard/sales-entry-list",
              type: "company",
              icon: "salesentry",
              permission: permissions?.includes("sales_entry_view"),
            },
            {
              name: "Sales Returns",
              link: "/dashboard/sales-return-list",
              type: "company",
              icon: "salesretrun",
              permission: permissions?.includes("sales_return_view"),
            },
            {
              name: "Other Sales Entry",
              link: "/dashboard/other-sales-entry-list",
              type: "company",
              icon: "othersalesentry",
              permission: permissions?.includes("other_sales_entry_view"),
            },
            {
              name: "LR Updation",
              link: "/dashboard/lr-update",
              type: "company",
              icon: "challanentry",
              permission: permissions?.includes("lr_updation_view"),
            },
          ],
        },
        {
          name: "Cash Bank Entry",
          link: "",
          type: "company",
          icon: "cashbankentry",
          permission: permissions?.includes("cash_back_entry_main_view"),
          child: [
            {
              name: "Cash Bank Entry",
              link: "/dashboard/cashbank-list",
              type: "company",
              icon: "cashbankentry",
              permission: permissions?.includes("cash_back_entry_view"),
            },
            {
              name: "Advance Adjustment",
              link: "/dashboard/advance-adjustment-list",
              type: "company",
              icon: "openingbalance",
              permission: permissions?.includes("advance_adjustment_view"),
              //  permission:true,
            },
            {
              name: "TDS Entry",
              link: "/dashboard/tds-entry-list",
              type: "company",
              icon: "taxmaster",
              permission: permissions?.includes("tds_entry_view"),
            },
            {
              name: "Bank Reco",
              link: "",
              type: "company",
              icon: "Banking",
              permission: permissions?.includes("bank_reco_main_view"),
              child: [
                {
                  name: "Bank Reco",
                  link: "/dashboard/bank-reco",
                  type: "company",
                  icon: "Banking",
                  permission: permissions?.includes("bank_reco_view"),
                },
                // {
                //   name: "Bank Reco Report",
                //   link: "/dashboard/bank-reco-report",
                //   type: "company",
                //   icon: "accountgroupmaster",
                //   permission: permissions?.includes("bank_reco_report_view"),
                // },
                {
                  name: "Bank Statement Upload",
                  link: "/dashboard/bank-statement-upload",
                  type: "company",
                  icon: "Banking",
                  permission: permissions?.includes("bank_statement_upload_view"),
                },
                {
                  name: "Auto Reco Dashboard",
                  link: "/dashboard/bank-reco-auto-dashboard",
                  type: "company",
                  icon: "Banking",
                  permission: permissions?.includes("bank_reco_auto_dashboard_view"),
                },
                {
                  name: "Auto Reco Report",
                  link: "/dashboard/bank-reco-auto-report",
                  type: "company",
                  icon: "Banking",
                  permission: permissions?.includes("bank_reco_auto_report_view"),
                },
              ],
            },

          ],
        },
        {
          name: "JV",
          link: "/dashboard/jv-list",
          type: "company",
          icon: "Jv",
          permission: permissions?.includes("jv_entry_view"),
        },
        {
          name: "Finish Entry",
          link: "/dashboard/finish-entry-list",
          type: "company",
          icon: "finishentery",
          permission: permissions?.includes("finish_entry_view"),
        },
      ],
    },
    {
      name: "Account Voucher Entry",
      type: "company",
      icon: "Voucher",
      permission: permissions?.includes("account_voucher_entry_view"),
      child: [
        {
          name: "Sales",
          link: "/dashboard/sales-voucher-entry-list",
          type: "company",
          icon: "salesentry",
          permission: permissions?.includes("voucher_entry_sales_view"),
        },
        {
          name: "Purchase",
          link: "/dashboard/purchase-voucher-entry-list",
          type: "company",
          icon: "purchaseions",
          permission: permissions?.includes("voucher_entry_purchase_view"),
        },
        {
          name: "Credit Note",
          link: "/dashboard/credit-note-entry-list",
          type: "company",
          icon: "salesretrun",
          permission: permissions?.includes("voucher_entry_credit_note_view"),
        },
        {
          name: "Debit Note(Purchase)",
          link: "/dashboard/debit-note-entry-list",
          type: "company",
          icon: "purchasereturn",
          permission: permissions?.includes(
            "voucher_entry_debit_note_purchase_view"
          ),
        },
        {
          name: "Debit Note(Sales)",
          link: "/dashboard/debit-note-sales-list",
          type: "company",
          icon: "salesentry",
          permission: permissions?.includes(
            "voucher_entry_debit_note_sales_view"
          ),
        },
      ],
    },
    {
      name: "Stock Transfer",
      type: "company",
      icon: "Stock",
      permission: permissions?.includes("stock_transfer_main_view"),
      child: [
        {
          name: "Stock Transfer",
          link: "/dashboard/stock-transfer-list",
          type: "company",
          icon: "materialstock",
          permission: permissions?.includes("stock_transfer_view"),
        },
        {
          name: "Surplus Wastage Entry",
          link: "/dashboard/surplus-wastage-list",
          type: "company",
          icon: "otherstock",
          permission: permissions?.includes("surplus_wastage_entry_view"),
        },
      ],
    },
    {
      name: "Reports",
      link: "",
      type: "company",
      icon: "Reportsgray",
      permission: permissions?.includes("report_main_view"),
      child: [
        {
          name: "Purchase Report",
          link: "",
          type: "company",
          icon: "purchasereport",
          permission: permissions?.includes("purchase_report_main_view"),
          child: [
            {
              name: "GRN Report",
              link: "/dashboard/grn-report",
              type: "company",
              icon: "grnreports",
              permission: permissions?.includes("grn_report_view"),
            },
            {
              name: "Purchase Register",
              link: "/dashboard/purchase-entry-report",
              type: "company",
              icon: "purchaseregister",
              permission: permissions?.includes("purchase_entry_report_view"),
            },
            {
              name: "Purchase Return Register",
              link: "/dashboard/purchase-return-report",
              type: "company",
              icon: "purchaseretruns",
              permission: permissions?.includes("purchase_return_report_view"),
            },
            {
              name: "Purchases More Than Amt",
              link: "/dashboard/other/purchases-more-than-amount",
              type: "company",
              icon: "stockreport",
              permission: permissions?.includes("purchases_more_than_amount_view"),
            },
          ],
        },
        {
          name: "Sales Report",
          link: "",
          type: "company",
          icon: "salesreports",
          permission: permissions?.includes("sales_report_main_view"),
          child: [
            {
              name: "Packing / Challan Reports",
              link: "/dashboard/packing-slip-report",
              type: "company",
              icon: "challanreport",
              permission: permissions?.includes("packing_challan_report_view"),
            },
            {
              name: "Sales Register",
              link: "/dashboard/sales-entry-report",
              type: "company",
              icon: "salesregiter",
              permission: permissions?.includes("sales_entry_report_view"),
            },
            {
              name: "Sales Returns Register",
              link: "/dashboard/sales-return-report",
              type: "company",
              icon: "salesregiterreturn",
              permission: permissions?.includes("sales_return_report_view"),
            },
            {
              name: "Sales More Than Amt",
              link: "/dashboard/other/sales-more-than-amount",
              type: "company",
              icon: "stockreport",
              permission: permissions?.includes("sales_more_than_amount_view"),
            },
          ],
        },
        {
          name: "Cashbank Report",
          link: "",
          type: "company",
          icon: "cashbankentry",
          permission: permissions?.includes("cash_bank_report_view"),
          child: [
            {
              name: "Bank Book",
              link: "/dashboard/cashbank-book-report",
              type: "company",
              icon: "Ledger",
              permission: permissions?.includes("bank_book_view"),
            },
            {
              name: "Cashbank Register",
              link: "/dashboard/cashbank-register-report",
              type: "company",
              icon: "accountgroupmaster",
              permission: permissions?.includes("cash_bank_register_view"),
            },
            {
              name: "Bank/Cash Summary",
              link: "/dashboard/other/bank-cash-summary",
              type: "company",
              icon: "cashbankentry",
              permission: permissions?.includes("cash_bank_register_view"),
            },
            {
              name: "Bulk NEFT/RTGS Payment",
              link: "/dashboard/other/bulk-neft-rtgs-payment",
              type: "company",
              icon: "Banking",
              permission: permissions?.includes("cash_bank_register_view"),
            },
            {
              name: "Daily Cash/Bank Summary",
              link: "/dashboard/other/daily-bank-cash-summary",
              type: "company",
              icon: "calendaricon",
              permission: permissions?.includes("cash_bank_register_view"),
            },
          ],
        },
        {
          name: "Journal Voucher Report",
          link: "/dashboard/jounral-voucher-report",
          type: "company",
          icon: "Jv",
          permission: permissions?.includes("journal_voucher_report_view"),
        },
        {
          name: "Ledger Report",
          link: "/dashboard/ledger-report",
          type: "company",
          icon: "Ledger",
          permission: permissions?.includes("ledger_report_view"),
        },
        {
          name: "Outstanding Report",
          link: "/dashboard/outstanding-report",
          type: "company",
          icon: "Ledger",
          permission: permissions?.includes("outstanding_report_view"),
        },

        {
          name: "Stock Report",
          link: "",
          type: "company",
          icon: "salesreports",
          permission: permissions?.includes("stock_report_main_view"),
          child: [
            {
              name: "Stock Report",
              link: "/dashboard/stock-report",
              type: "company",
              icon: "stockreport",
              permission: permissions?.includes("stock_report_view"),
            },
            {
              name: "Material Stock Report",
              link: "/dashboard/material-stock-report",
              type: "company",
              icon: "materialstock",
              permission: permissions?.includes("material_stock_report_view"),
            },
            {
              name: "Opening stock Report",
              link: "/dashboard/other/opening-stock-report",
              type: "company",
              icon: "stockreport",
              permission: permissions?.includes("opening_stock_report_view"),
            },
          ],
        },

        {
          name: "Master Report",
          link: "",
          type: "company",
          icon: "salesreports",
          permission: permissions?.includes("master_report_view"),
          child: [
            {
              name: "Account Report",
              link: "/dashboard/account-report",
              type: "company",
              icon: "accountmaster",
              permission: permissions?.includes("account_report_view"),
            },
            {
              name: "Product Master Report",
              link: "/dashboard/product-master-report",
              type: "company",
              icon: "productmaster",
              permission: permissions?.includes("product_master_report_view"),
            },
            {
              name: "Tax Master Report",
              link: "/dashboard/other/tax-master-report",
              type: "company",
              icon: "stockreport",
              permission: permissions?.includes("tax_master_report_view"),
            },
            {
              name: "Price List Report",
              link: "/dashboard/other/price-list-report",
              type: "company",
              icon: "stockreport",
              permission: permissions?.includes("price_list_report_view"),
            },
          ],
        },

        {
          name: "TDS Report",
          link: "/dashboard/tds-report",
          type: "company",
          icon: "taxmaster",
          permission: permissions?.includes("tds_report_view"),
        },

        {
          name: "Commission Report",
          link: "/dashboard/commission-report",
          type: "company",
          icon: "stockreport",
          permission: permissions?.includes("commission_report_view"),
        },
        {
          name: "Final Account Statement",
          link: "",
          type: "company",
          icon: "Finaccount",
          permission: permissions?.includes("final_account_report_view"),
          child: [
            {
              name: "Trial Balance",
              link: "/dashboard/trial-balance-report",
              type: "company",
              icon: "Ledger",
              permission: permissions?.includes("final_account_report_view"),
            },
            {
              name: "Details Trial Balance",
              link: "/dashboard/other/detailed-trial-balance",
              type: "company",
              icon: "Ledger",
              permission: permissions?.includes("final_account_report_view"),
            },
            {
              name: "Profit & Loss",
              link: "/dashboard/profit-loss-report",
              type: "company",
              icon: "Finaccount",
              permission: permissions?.includes("final_account_report_view"),
            },

            {
              name: "Monthly Profit And Loss",
              link: "/dashboard/monthly-profit-loss-report",
              type: "company",
              icon: "Graph",
              permission: permissions?.includes("final_account_report_view"),
            },
            {
              name: "Balance Sheet",
              link: "/dashboard/balance-sheet-report",
              type: "company",
              icon: "Finaccount",
              permission: permissions?.includes("final_account_report_view"),
            },
            {
              name: "Balance Sheet Order Setting",
              link: "/dashboard/balance-sheet-order-setting",
              type: "company",
              icon: "processmaster",
              permission: permissions?.includes("final_account_report_view"),
            },

            {
              name: "SCH VI Balance Sheet",
              link: "/dashboard/other/schvi-balance-sheet",
              type: "company",
              icon: "Finaccount",
              permission: permissions?.includes("final_account_report_view"),
            },
            {
              name: "Opening Trial Balance Report",
              link: "/dashboard/other/opening-trial-balance-report",
              type: "company",
              icon: "openingbalance",
              permission: permissions?.includes("final_account_report_view"),
            },
            {
              name: "Audit Trail Report",
              link: "/dashboard/other/audit-trail",
              type: "company",
              icon: "Posting",
              permission: permissions?.includes("final_account_report_view"),
            },
          ],
        },

        {
          name: "GST Report",
          link: "",
          type: "company",
          icon: "taxmaster",
          permission: permissions?.includes("gst_report_main_view"),
          child: [
            {
              name: "GSTR Report",
              link: "/dashboard/other/gst-report",
              type: "company",
              icon: "taxmaster",
              permission: permissions?.includes("gst_report_view"),
            },
            {
              name: "GSTR-3B Summary",
              link: "/dashboard/other/gstr3b-summary",
              type: "company",
              icon: "taxmaster",
              permission: permissions?.includes("gstr3b_summary_view"),
            },
            {
              name: "GST 2B Upload",
              link: "/dashboard/other/gst2b-upload",
              type: "company",
              icon: "taxmaster",
              permission: permissions?.includes("gst2b_upload_view"),
            },
            {
              name: "GST 2B Dashboard",
              link: "/dashboard/other/gst2b-dashboard",
              type: "company",
              icon: "taxmaster",
              permission: permissions?.includes("gst2b_dashboard_view"),
            },
            {
              name: "GST 2B Reconciliation Report",
              link: "/dashboard/other/gst2b-reconciliation",
              type: "company",
              icon: "taxmaster",
              permission: permissions?.includes("gst2b_reconciliation_view"),
            },

          ],
        },
        {
          name: "Other Reports",
          link: "",
          type: "company",
          icon: "salesreports",
          permission: permissions?.includes("other_reports_main_view"),
          child: [


            {
              name: "Depreciation Report",
              link: "/dashboard/other/depreciation-report",
              type: "company",
              icon: "fixedasset",
              permission: permissions?.includes("depreciation_report_view"),
            },
            {
              name: "Interest Calculation (Bill)",
              link: "/dashboard/other/interest-calculation-report",
              type: "company",
              icon: "stockreport",
              permission: permissions?.includes("interest_calculation_bill_view"),
            },
            {
              name: "Interest Calculation (Loan)",
              link: "/dashboard/other/interest-calculation-loan",
              type: "company",
              icon: "stockreport",
              permission: permissions?.includes("interest_calculation_loan_view"),
            },
            {
              name: "Advance List Report",
              link: "/dashboard/other/advance-list-report",
              type: "company",
              icon: "openingbalance",
              permission: permissions?.includes("advance_list_report_view"),
            },
            {
              name: "Scheduled Mail Log",
              link: "/dashboard/other/scheduled-mail-log",
              type: "company",
              icon: "openingbalance",
              permission: true,
            },
            {
              name: "Ledger VS Outstanding",
              link: "/dashboard/other/ledger-vs-outstanding",
              type: "company",
              icon: "Ledger",
              permission: permissions?.includes("ledger_vs_outstanding_view"),
            },

            {
              name: "Cash Flow Statement",
              link: "/dashboard/other/cash-flow-statement",
              type: "company",
              icon: "Finaccount",
              permission: permissions?.includes("cash_flow_statement_view"),
            },
            {
              name: "Fund Flow Statement",
              link: "/dashboard/other/fund-flow-statement",
              type: "company",
              icon: "Finaccount",
              permission: permissions?.includes("fund_flow_statement_view"),
            },





            {
              name: "Sales Purchase Comparison Report",
              link: "/dashboard/other/sales-purchase-comparison-report",
              type: "company",
              icon: "Trading",
              permission: permissions?.includes("sales_purchase_comparison_report_view"),
            },

            {
              name: "Analysis Report",
              link: "/dashboard/other/analysis-report",
              type: "company",
              icon: "Graph",
              permission: permissions?.includes("analysis_report_view"),
            },

            {
              name: "Cost Report",
              link: "/dashboard/other/cost-report",
              type: "company",
              icon: "costgroupmaster",
              permission: permissions?.includes("cost_report_view"),
            },



          ],
        },
      ],
    },
    {
      name: "Order Processing",
      type: "company",
      icon: "orderprocessing",
      permission: permissions?.includes("order_processing_view"),
      child: [
        {
          name: "Purchase Order",
          link: "",
          type: "company",
          icon: "purchaseorder",
          permission: permissions?.includes("purchase_order_main_view"),
          child: [
            {
              name: "Purchase Order",
              link: "/dashboard/purchase-order",
              type: "company",
              icon: "innerpurchaseorder",
              permission: permissions?.includes("purchase_order_module_view"),
            },
            {
              name: "Purchase Order Report",
              link: "/dashboard/purchase-order-report",
              type: "company",
              icon: "purchaseorderreport",
              permission: permissions?.includes("purchase_order_report_view"),
            },
          ],
        },
        {
          name: "Sales Order",
          link: "",
          type: "company",
          icon: "salesorderport",
          permission: permissions?.includes("sales_order_main_view"),
          child: [
            {
              name: "Sales Order",
              link: "/dashboard/sales-order-list",
              type: "company",
              icon: "salesorder",
              permission: permissions?.includes("sales_order_module_view"),
            },
            {
              name: "Sales Order Report",
              link: "/dashboard/sales-order-report",
              type: "company",
              icon: "salesorderport",
              permission: permissions?.includes("sales_order_report_view"),
            },
          ],
        },
      ],
    },
    {
      name: "Manage Users",
      type: "company",
      icon: "manageuser",
      permission: permissions?.includes("manage_users_view"),
      child: [
        {
          name: "Role Master",
          link: "/dashboard/roles",
          type: "company",
          icon: "rolemaster",
          permission:
            type == "admin" || permissions?.includes("role_master_view"),
        },
        {
          name: "User Creation",
          link: "/dashboard/manage-users",
          type: "company",
          icon: "usercreation",
          permission: permissions?.includes("user_creation_view"),
        },
      ],
    },
    {
      name: "Master",
      type: "admin",
      permission: true,
      icon: "mastericon",
      child: [
        {
          name: "Country Master",
          link: "/dashboard/country-master",
          type: "admin",
          icon: "countrymaster",
          permission: true,
        },
        {
          name: "State Master",
          link: "/dashboard/state-master",
          type: "admin",
          icon: "statemaster",
          permission: true,
        },
        {
          name: "City Master",
          link: "/dashboard/city-master",
          type: "admin",
          icon: "citymaster",
          permission: true,
        },
        {
          name: "Unit Master",
          link: "/dashboard/unit-master",
          type: "admin",
          icon: "unitmaster",
          permission: true,
        },
        {
          name: "Zone Master",
          link: "/dashboard/zone-master",
          type: "admin",
          icon: "zonemaster",
          permission: true,
        },
        {
          name: "Year Master",
          link: "/dashboard/year-master",
          type: "admin",
          icon: "yearmaster",
          permission: true,
        },
      ],
    },

    {
      name: "Utility",
      link: "",
      type: "company",
      icon: "utilityicon",
      permission: type != "admin" && permissions?.includes("utility_view"),
      child: [
        {
          name: "Location Report",
          link: "/dashboard/location-report",
          type: "company",
          icon: "location",
          permission: permissions?.includes("location_report_view"),
        },
        {
          name: "Cheque print",
          link: "/dashboard/Cheque-Envelope-list",
          type: "company",
          icon: "cashbankentry",
          permission: permissions?.includes("cheque_print_view"),
        },
        {
          name: "Letter Master",
          link: "/dashboard/letter-master",
          type: "company",
          icon: "stockreport",
          permission: permissions?.includes("letter_master_view"),
        },
        {
          name: "Auto Report Mail",
          link: "/dashboard/auto-report-mail",
          type: "company",
          icon: "stockreport",
          // Needs BOTH: Super Admin has "Email Integration" checked under
          // Utility in this company's Company Setup, AND this role has
          // the auto_report_mail permission checked in Role Master.
          permission:
            companySetup?.utility?.emailIntegration === true &&
            permissions?.includes("auto_report_mail_view"),
        },
      ],
    },
  ];

  // A menu entry with children (e.g. "Daily Entry") should only show up if
  // it also has its own _view permission AND at least one child is
  // actually visible — otherwise it renders as a dropdown with nothing in
  // it. Walks bottom-up so a grandparent correctly reflects a
  // grandchild's visibility too.
  const applyEffectivePermission = (node) => {
    if (Array.isArray(node.child) && node.child.length) {
      node.child.forEach(applyEffectivePermission);
      const anyChildVisible = node.child.some((c) => c.permission);
      node.permission = !!node.permission && anyChildVisible;
    }
    return node;
  };
  masterMaintenanceMenuList.forEach(applyEffectivePermission);

  const masterArray = [
    "/dashboard/unit-master",
    "/dashboard/area-master",
    "/dashboard/country-master",
    "/dashboard/state-master",
    "/dashboard/city-master",
    "/dashboard/zone-master",
    "/dashboard/godwon-master",
    "/dashboard/narration-master",
    "/dashboard/process-master",
    "/dashboard/size-master",
    "/dashboard/colour-master",
    "/dashboard/set-master",
    "/dashboard/HSN-master",
  ];

  const masterArray2 = [
    "/dashboard/tax-category-master",
    "/dashboard/product-category-master",
    "/dashboard/prouduct-group-master",
    "/dashboard/product-master",
    "/dashboard/finish-stock",
    "/dashboard/opening-stock",
  ];
  return (
    <>
      <div className="sidebar-main">
        <ul className="ul-sidebar-list">
          {(type != "admin" && permissions?.includes("dashboard_view")) && (
              <li
                className={
                  location.pathname == "/dashboard/home"
                    ? "li-sidebar-list active"
                    : "li-sidebar-list"
                }
              >
                <NavLink
                  activeClassName="active"
                  className="redirect-sidebar-page"
                  to={"home"}
                  onClick={closeSidebar}
                >
                  <div className="sidebar-btn-list">
                    <img
                      src={Index.Svg.dashboardicon}
                      className="sidebar-icons"
                    ></img>Dashboard
                  </div>
                </NavLink>
              </li>
            )}
          {type === "admin" && (
            <li
              className={
                location.pathname == "/dashboard/client-list"
                  ? "li-sidebar-list active"
                  : "li-sidebar-list"
              }
            >
              <NavLink
                activeClassName="active"
                className="redirect-sidebar-page"
                to={"client-list"}
                onClick={closeSidebar}
              >
                <div className="sidebar-btn-list">
                  <img
                    src={Index.Svg.clientmaster}
                    className="sidebar-icons"
                  ></img>Client Master
                </div>
              </NavLink>
            </li>
          )}

          <MenuItemList array={masterMaintenanceMenuList} type={type} closeSidebar={closeSidebar} />

          {/* Needs BOTH: Super Admin has "Tally" checked under Utility in
              this company's Company Setup, AND this role has the
              tally_integration permission checked in Role Master. */}
          {type != "admin" &&
            companySetup?.utility?.telly === true &&
            permissions?.includes("tally_integration_view") && (
            <li
              className={
                location.pathname === "/dashboard/tally-integration"
                  ? "li-sidebar-list active"
                  : "li-sidebar-list"
              }
            >
              <NavLink
                activeClassName="active"
                className="redirect-sidebar-page"
                to={"/dashboard/tally-integration"}
                onClick={closeSidebar}
              >
                <div className="sidebar-btn-list">
                  <img
                    src={Index.Svg.purchaselist}
                    className="sidebar-icons"
                  ></img>Tally Integration
                </div>
              </NavLink>
            </li>
          )}


          {/* {type != "admin" && permissions?.includes("manage_users_view") && (
              <li className="li-sidebar-list">
                <Index.Link className="redirect-sidebar-page">
                  <div className="sidebar-btn-list">
                    <div className="svg_img_main">
                      <img
                        src={Index.Svg.Dailyentrygray}
                        className="side_logo"
                      ></img>
                      <img
                        src={Index.Svg.Dailyentrywhite}
                        className="side_logo_white"
                      ></img>
                    </div>
                    <div className="sidebar_text_details">
                      <Index.Link to="/dashboard/manage-users">
                        <Index.Typography
                          variant="p"
                          component="p"
                          className="sidebar-title"
                        >
                          Manage Users
                        </Index.Typography>
                      </Index.Link>
                    </div>
                  </div>
                </Index.Link>
              </li>
            )} */}

          {/* {type != "admin" && permissions?.includes("reports_view") && (
              <li className="li-sidebar-list">
                <Index.Link
                  to="/dashboard/stock-report"
                  className="redirect-sidebar-page"
                >
                  <div className="sidebar-btn-list">
                    <div className="svg_img_main">
                      <img
                        src={Index.Svg.Reportsgray}
                        className="side_logo"
                      ></img>
                      <img
                        src={Index.Svg.Reportswhite}
                        className="side_logo_white"
                      ></img>
                    </div>
                    <div className="sidebar_text_details">
                      <Index.Typography
                        variant="p"
                        component="p"
                        className="sidebar-title"
                      >
                        Reports
                      </Index.Typography>
                    </div>
                  </div>
                </Index.Link>
              </li>
            )} */}

          {/* {(type === "company" && permissions?.includes("order_processing_view")) && (
            <li className={
              location.pathname == "/dashboard/sales-order-list"
                ? "li-sidebar-list active"
                : "li-sidebar-list"
            }>
              <Index.Link className="redirect-sidebar-page">
                <div className="sidebar-btn-list">
                  <div className="svg_img_main">
                    <img src={Index.Svg.ordergray} className="side_logo"></img>
                    <img
                      src={Index.Svg.orderwhite}
                      className="side_logo_white"
                    ></img>
                  </div>
                  <div className="sidebar_text_details">
                  <Index.Link to="/dashboard/sales-order-list">
                    <Index.Typography
                      variant="p"
                      component="p"
                      className="sidebar-title"
                    >
                      Order Processing
                    </Index.Typography>
                    </Index.Link>
                  </div>
                </div>
              </Index.Link>
            </li>)} */}

          {/* {type === "company" && (
            <li className={
              location.pathname == "/dashboard/packing-slip-list"
                ? "li-sidebar-list active"
                : "li-sidebar-list"
            }>
              <Index.Link className="redirect-sidebar-page">
                <div className="sidebar-btn-list">
                  <div className="svg_img_main">
                    <img src={Index.Svg.ordergray} className="side_logo"></img>
                    <img
                      src={Index.Svg.orderwhite}
                      className="side_logo_white"
                    ></img>
                  </div>
                  <div className="sidebar_text_details">
                  <Index.Link to="/dashboard/packing-slip-list">
                    <Index.Typography
                      variant="p"
                      component="p"
                      className="sidebar-title"
                    >
                      Packing Slip
                    </Index.Typography>
                    </Index.Link>
                  </div>
                </div>
              </Index.Link>
            </li>)} */}

          {/* {type != "admin" && permissions?.includes("utility_view") && (
            <li className="li-sidebar-list">
              <Index.Link className="redirect-sidebar-page">
                <div className="sidebar-btn-list">
                  <img
                    src={Index.Svg.utilityicon}
                    className="sidebar-icons"
                  ></img>
                  <Index.Typography
                    variant="p"
                    component="p"
                    className="sidebar-title"
                  >
                    Utility
                  </Index.Typography>
                </div>
              </Index.Link>
            </li>
          )} */}
        </ul>
      </div>
    </>
  );
}

export default SideBar;
